import { MessageBar, MessageBarBody, makeStyles, tokens } from '@fluentui/react-components';
import { MainContext, useT } from '@powerportalspro/react';
import {
  GridToolbarItems,
  MainGrid,
  MenuBar,
  NavigateNewRecordGridButton,
  RefreshContextButton,
  SaveContextButton,
} from '@powerportalspro/react-fluent';
import { useMemo, useState } from 'react';
import { EDITABLE_CONTACTS_VIEW_ID, getEditableContactsView } from './AccountAndContactCustomViews';

// The contacts, in a grid that opens in edit mode. `allowEdit` puts an Editable switch in the
// grid's menu, and `editable` turns it on to begin with. Each column becomes the editor its
// column's type calls for, with no wiring per column: text boxes for the names and email, a lookup
// for the company, a drop-down for the gender, a date picker for the birthday, a money box for the
// credit limit and a switch for "Do not allow Emails".
//
// An edit is held by the row until the Save button in the MainContext's menu writes every changed
// row at once; Refresh throws the changes away. A row is editable only when the signed-in user may
// write to it, so the sample contacts everyone sees stay read-only, and the contacts you add with
// New can be edited here.

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.GridDemos.InlineEditingMainDemo';

const CONTACT_URL = 'demos/contact';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalMNudge,
  },
});

export function InlineEditingMainSample() {
  const styles = useStyles();
  const t = useT();

  // The `editable` prop is controlled: the state starts it on, and `onEditableChanged` keeps the
  // grid menu's switch working.
  const [editable, setEditable] = useState(true);

  const views = useMemo(
    () => [getEditableContactsView(t(`${STRINGS_BASE}.view-contacts`))],
    [t],
  );

  return (
    <div className={styles.root}>
      <MessageBar intent="warning" layout="multiline">
        <MessageBarBody>{t(`${STRINGS_BASE}.login-required`)}</MessageBarBody>
      </MessageBar>

      <MainContext>
        <MenuBar>
          <SaveContextButton />
          <RefreshContextButton />
        </MenuBar>

        <MainGrid
          tableName="contact"
          minHeight="550px"
          maxHeight="550px"
          allowEdit
          editable={editable}
          onEditableChanged={setEditable}
          viewIds={[EDITABLE_CONTACTS_VIEW_ID]}
          customViewDefinitions={views}
          defaultViewId={EDITABLE_CONTACTS_VIEW_ID}
        >
          <GridToolbarItems>
            <NavigateNewRecordGridButton url={CONTACT_URL} />
          </GridToolbarItems>
        </MainGrid>
      </MainContext>
    </div>
  );
}
